import { render } from "./Subject.vue?vue&type=template&id=8c3e0a48&ts=true"
import script from "./Subject.vue?vue&type=script&lang=ts"
export * from "./Subject.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__